export function cn(...classes:any) {
    return classes.filter(Boolean).join(' ');
}

export const metaDetailsHome = {
  title: "MetaFox Tech | web design and development company",
  description:
    "Experience the expertise of a leading web design and development company, dedicated to delivering high-quality and innovative digital solutions ",
  keyWord: "MetaFox",
};

export const metaDetailsAbout = {
  title: "About Us | Best web design and development company",
  description:
    "Aeon Tech Delivering top-notch web design and development solutions tailored to meet your unique business requirements",
  keyWord: "MetaFox",
};

export const metaDetailsServices = {
  title: "MetaFox | One Place Solutions for Digital Web Services",
  description:
    "One stop solutions for your web design, mobile application development, branding and custom build website dev services. Contact us today for a custom quote.",
  keyWord: "MetaFox",
};

export const metaDigitalMarketing = {
  title: "MetaFox | Elevate Your Online Presence with Meta Fox Digital Marketing",
  description:
    "Accelerate your digital journey with Meta Fox's expert digital marketing services. From SEO and PPC to social media and content marketing, we deliver results.",
  keyWord: "MetaFox",
};

export const metaWebDevelopment = {
  title: "MetaFox | Elevate Your Digital Presence with MetaFox Web Development",
  description:
    "Experience cutting-edge web development solutions with MetaFox. Our expert team crafts stunning, responsive websites that captivate users and drive business growth.",
  keyWord: "web development, web design, web application, e-commerce",
};

export const metaMobileAppDevelopment = {
  title: "MetaFox | Revolutionize Your Business with Cutting-Edge Mobile Apps",
  description:
    "Elevate your brand and reach a wider audience with our innovative mobile app development services. From concept to launch, we deliver exceptional apps that drive user engagement and business growth.",
  keyWord: "mobile app development, app development, iOS app development, Android app development, cross-platform app development, hybrid app development, mobile app design, UI/UX design, mobile app testing, app store optimization, ASO, mobile backend development, mobile app maintenance, mobile app security",
};

export const metaAiDevelopment = {
  title: "AI Solutions | Custom AI Development | Machine Learning",
  description: "Elevate Your Business with AI: Expert AI Consulting and Development",
  keyWord: "AI Development Services | Machine Learning | Data Science | AI Consulting",
};

export const metaItConsulting = {
  title: "IT Consulting | Digital Transformation | Cloud Solutions",
  description: "Elevate Your Business with Expert IT Consulting and Strategy",
  keyWord: "IT Consulting Services | Digital Transformation | Cloud Solutions | IT Strategy",
};

export const metaUIdevelopment = {
  title: "Professional UI/UX Design Services | Enhance User Experience & Interface Design",
  description: "Transform your digital products with MetaFox’s expert UI/UX design services. We create intuitive, user-centered designs that enhance usability, engagement, and overall user satisfaction across all devices.",
  keyWord: `UI/UX design services, user interface design, user experience design, responsive web design, mobile UI design, interactive design, design systems, usability testing, prototyping,
  wireframing, UI/UX design agency, custom UI design, user research, accessibility design, digital product design.`,
};

export const metaHireDedicated = {
  title: "Hire Dedicated Developers at MetaFox – Expert Web, Mobile & Custom Software Development",
  description: `Looking for dedicated developers? At MetaFox, we offer expert development services including custom software, web, and mobile app development.
  Our dedicated team ensures high-quality, scalable, and secure solutions tailored to your business needs.
  Contact us today to get started!`,
  keyWord: `Hire,hire dedicated developer,metafox`,
};

export const metaAmazonPPC = {
  title: "PPC Advertising Services | Drive Sales with Ads – MetaFox",
  description: `Boost your sales with high-ROI PPC advertising campaigns from MetaFox. Our experts manage Sponsored Products, Brands, and Video ads to lower ACOS and increase conversions with data-driven strategies.`,
  keyWord: `PPC, advertising services, Sponsored Product ads, MetaFox PPC`,
};

// const itConsultingService = {
//   id: 'it-consulting',
//   title: 'IT Consulting',
//   subtitle: 'Strategic Technology Consulting',
//   description: 'Transform your business with strategic IT consulting services. Our experienced consultants help you optimize technology infrastructure, improve operational efficiency, and drive digital transformation initiatives.',
//   heroImage: 'https://images.unsplash.com/photo-1582004531564-50f300aae039?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxJVCUyMGNvbnN1bHRpbmclMjB0ZWNobm9sb2d5fGVufDF8fHx8MTc1ODIxODM4Mnww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
//   features: [
//     {
//       icon: Settings,
//       title: 'Infrastructure Assessment',
//       description: 'Comprehensive evaluation of your current IT infrastructure to identify optimization opportunities and security gaps.'
//     },
//     {
//       icon: TrendingUp,
//       title: 'Digital Transformation',
//       description: 'Strategic roadmaps for digital transformation initiatives that align technology with business objectives.'
//     },
//     {
//       icon: Shield,
//       title: 'Cybersecurity Strategy',
//       description: 'Robust security frameworks and best practices to protect your business from evolving cyber threats.'
//     },
//     {
//       icon: Cloud,
//       title: 'Cloud Migration',
//       description: 'Expert guidance for cloud adoption and migration strategies that reduce costs and improve scalability.'
//     },
//     {
//       icon: Database,
//       title: 'Data Management',
//       description: 'Data governance strategies and analytics solutions to unlock the value of your business data.'
//     },
//     {
//       icon: Lightbulb,
//       title: 'Innovation Strategy',
//       description: 'Technology innovation roadmaps that keep you ahead of competition and market trends.'
//     }
//   ],
//   process: [
//     {
//       step: 1,
//       title: 'Current State Assessment',
//       description: 'Conduct thorough analysis of your existing IT infrastructure, processes, and business requirements.'
//     },
//     {
//       step: 2,
//       title: 'Gap Analysis & Strategy',
//       description: 'Identify gaps between current and desired state, then develop comprehensive strategic recommendations.'
//     },
//     {
//       step: 3,
//       title: 'Roadmap Development',
//       description: 'Create detailed implementation roadmaps with timelines, budgets, and resource requirements.'
//     },
//     {
//       step: 4,
//       title: 'Implementation Support',
//       description: 'Provide hands-on support during implementation phases to ensure successful project delivery.'
//     },
//     {
//       step: 5,
//       title: 'Ongoing Optimization',
//       description: 'Continuous monitoring and optimization to ensure your IT investments deliver maximum business value.'
//     }
//   ],
//   benefits: [
//     'Improved operational efficiency and productivity',
//     'Reduced IT costs and infrastructure overhead',
//     'Enhanced security and compliance posture',
//     'Better alignment of IT with business goals',
//     'Faster time-to-market for new initiatives',
//     'Improved scalability and flexibility',
//     'Access to latest technologies and best practices',
//     'Risk mitigation and business continuity',
//     'Data-driven decision making capabilities',
//     'Competitive advantage through technology innovation'
//   ],
//   technologies: [
//     'AWS', 'Microsoft Azure', 'Google Cloud', 'Kubernetes', 'Docker',
//     'Terraform', 'Ansible', 'Jenkins', 'Monitoring Tools', 'Security Frameworks',
//     'Data Analytics', 'AI/ML Platforms', 'DevOps Tools', 'Enterprise Software'
//   ],
//   cta: {
//     title: 'Ready to Transform Your IT Strategy?',
//     description: 'Unlock the full potential of technology for your business. Let our IT consulting experts guide your digital transformation journey.',
//     buttonText: 'Start IT Consulting'
//   }
// };
